import { RootState } from "../../../../system/redux/store/community-finder-redux-store";

export const selectCurrentMatchedPage = (state: RootState) =>
	state?.results?.pagination?.currentMatchedPage;
